import systemCodeReducer from "./systemCodeReducer";

const systemCodeReducers = {
    systemCode: systemCodeReducer
}

export default systemCodeReducers